<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="passengerAudits && passengerAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list (nextPage)="onNextPage()" [audits]="passengerAudits">
    </sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Passenger audits </ng-template>
</ng-template>
